/**
 * Created by cl-macmini-51 on 17/07/18.
 */
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ModalType } from '../../constants/constant';
import { SessionService} from '../../services/session.service';
// import { layer, slideup } from '../../../../animations/common.animation'

@Component({
  moduleId: module.id,
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  // animations: [layer, slideup]
})
export class ModalComponent implements OnInit {
  @Input() header: string;
  @Input() minHeight: string = '';
  @Input() minWidth: string = '';
  @Input() modalType: string = ModalType.LARGE;
  @Input() showCross: boolean;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  isnewhybridapp=false;
  @Input() staticBackdrop: boolean = false;
  
  constructor(public sessionservice:SessionService) {
   }

  ngOnInit() {
    this.isnewhybridapp=this.sessionservice.ismobiledevice()
  }

  onCloseClick(e) {
    if (this.staticBackdrop) return;
    this.onClose.emit(true);
    this.removeLocalStorage();
  }
  
  removeLocalStorage()
  {
    this.sessionservice.remove('googleToken');
    this.sessionservice.remove('googleEmail');
    this.sessionservice.remove('googleVendorName');
    this.sessionservice.remove('googleVendorImage');
    this.sessionservice.remove('fb_name');
    this.sessionservice.remove('fb_id');
    this.sessionservice.remove('fb_email');
  }

  onOuterClick(e: MouseEvent) {
    if (this.staticBackdrop) return;
    if ((e.target as HTMLElement).classList.contains('modal')) {
      this.onCloseClick(e);
    }
  }

}
